import AddIcon from '@mui/icons-material/Add'
import { Button } from '@mui/material'
import { TopToolbar, useTranslate } from 'react-admin'

interface RetailerAddressListToolbarProps {
    resource: string
    handleCreateCallback: () => void
}

const RetailerAddressListToolbar = ({
    resource,
    handleCreateCallback
}: RetailerAddressListToolbarProps) => {
    const translate = useTranslate()

    return (
        <TopToolbar>
            <Button color="primary" variant={'outlined'} onClick={handleCreateCallback}>
                <AddIcon />
                {translate(`manager.resources.${resource}.add`)}
            </Button>
        </TopToolbar>
    )
}

export default RetailerAddressListToolbar
